import { render, staticRenderFns } from "./employeeCommission.vue?vue&type=template&id=40a9b991"
import script from "./employeeCommission.vue?vue&type=script&lang=js"
export * from "./employeeCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports